// Cupom e cashback de um produto no cardápio, pelas promoções que valem pra ele
// agora. É a MESMA regra do checkout (isItemPromotional e couponableSubtotal) e do
// servidor: promoção fixa e "de/por" não geram cashback; a oferta da Campanha
// Inteligente segue os switches "acumula com cupom" e "acumula com cashback".

const cobre = (promo, productId) =>
  (promo?.products || []).some((pp) => String(pp.product_id) === String(productId));
const aceitaCupom = (promo) => promo.accepts_coupon === 1 || promo.accepts_coupon === true;

export function beneficiosDoProduto(product, promocoes) {
  const lista = (promocoes || []).filter((p) => cobre(p, product?.id));
  const fixas = lista.filter((p) => !p.is_daily_offer);
  const oferta = lista.find((p) => p.is_daily_offer);
  const cheio = Number(product?.original_price || 0);
  const preco = Number(product?.sale_price || 0);
  const dePor = cheio > 0 && preco > 0 && cheio > preco;
  return {
    aceitaCupom: lista.every(aceitaCupom),
    ganhaCashback: fixas.length === 0 && (oferta ? !!oferta.acumula_cashback : !dePor),
  };
}

// Item do carrinho: o que já entrou marcado com oferta segue a marca dele.
export function itemAceitaCupom(item, promocoes) {
  if (item?.oferta_chave) return !!item.oferta_acumula_cupom;
  const id = item?.product_id || item?.id;
  return (promocoes || []).filter((p) => cobre(p, id)).every(aceitaCupom);
}

export function nomesSemCupom(cart, promocoes) {
  return [...new Set((cart || []).filter((i) => !itemAceitaCupom(i, promocoes)).map((i) => i.name).filter(Boolean))];
}

export function juntarNomes(nomes) {
  if (nomes.length <= 1) return nomes[0] || "";
  return `${nomes.slice(0, -1).join(", ")} e ${nomes[nomes.length - 1]}`;
}
